import { Reducer } from "redux";

import {
    INSTALL_PROMPT_SET_READY,
    InstallPromptSetReadyAction,
} from "@/mk2/containers/InstallPrompt/InstallPrompt.actions";

export interface InstallPromptState {
    ready: boolean;
}

const initialInstallPromptState: InstallPromptState = {
    ready: false,
};

export const installPromptReducer: Reducer<InstallPromptState> = (
    state: InstallPromptState = initialInstallPromptState,
    action: InstallPromptSetReadyAction,
) => {
    switch (action.type) {
        case INSTALL_PROMPT_SET_READY:
            return {
                ...state,
                ready: action.ready,
            };
        default:
            return state;
    }
};
